import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import { Modal, ModalBody } from 'components/qstrap'
import API from 'utils/API'
import csrfToken from 'utils/csrfToken'
import AccessToken from 'utils/AccessToken'

import Button from 'components/atoms/Button'
import Checkbox from 'components/atoms/Checkbox'
import Typography from 'components/atoms/Typography'

const CompleteSignUpNotice = ({ currentUser, agreedToCampusTerms, agreedToCampusPolicy }) => {
  const [agreement, setAgreement] = useState(false)
  const [hideModal, setHideModal] = useState(false)
  const hideThis = () => {
    setAgreement(false)
    setHideModal(true)
  }

  const declineTerms = () => {
    window.location.href = '/logout'
  }

  const acceptTnc = async () => {
    const options = {
      headers: {
        'X-CSRF-Token': csrfToken(),
        authorization: `BEARER ${decodeURIComponent(AccessToken.get())}`,
      },
    }

    await API.post(API.endPoints().common.term_agreement, {}, options)
    hideThis()
  }

  const showPopup = () => currentUser !== null && !(agreedToCampusTerms && agreedToCampusPolicy)

  if (hideModal || !showPopup()) {
    return null
  }
  return (
    <div>
      <Modal autoFocus={false} isOpen fade={false} className="terms-policy">
        <ModalBody>
          <div className="terms-policy__message">
            <Typography variant="subheading" component="h4" className="terms-policy__title">
              Syarat & Ketentuan dan Kebijakan Privasi Quipper Campus
            </Typography>
            <div className="terms-policy__content">
              <Typography variant="subbody" component="div" className="terms-policy__text">
                Untuk melanjutkan akses ke Quipper Campus, kamu perlu membaca dan menyetujui{' '}
                <a href="/terms" target="_blank" rel="noopener" className="terms-policy__link">
                  {' '}
                  Syarat dan Ketentuan
                </a>{' '}
                dan{' '}
                <a href="/policy" target="_blank" rel="noopener" className="terms-policy__link">
                  {' '}
                  Kebijakan Privasi
                </a>{' '}
                kami.
              </Typography>

              <Typography variant="subbody" component="div" className="terms-policy__text">
                Jika kamu tidak menyetujui Syarat & Ketentuan dan Kebijakan Privasi, klik Tolak dan sistem akan keluar otomatis.
              </Typography>
              <div className="terms-policy__checkbox-container">
                <Checkbox
                  className="terms-policy__checkbox"
                  checked={agreement}
                  onChange={() => setAgreement(!agreement)}
                  id="campus-terms-agreement"
                  name="campus-terms-agreement"
                >
                  <Typography variant="subbody" component="div" className="terms-policy__text">
                    Kamu telah membaca, mengerti, dan menyetujui Syarat & Ketentuan dan Kebijakan Privasi Quipper Campus.
                    Persetujuan ini harus diberikan oleh orang tua dan/atau wali jika kamu masih di bawah umur.
                  </Typography>
                </Checkbox>
              </div>
            </div>
          </div>
          <div className="terms-policy__btn-group">
            <Button component="button" variant="secondary" onClick={() => declineTerms()}>Tolak</Button>
            <Button
              component="button"
              disabled={!agreement}
              onClick={() => acceptTnc()}
              className={`btn ${agreement ? 'btn-primary' : 'disabled'}`}
            >
              Setuju
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <style jsx global>
        {`
          .modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            &-backdrop {
              opacity: 0.8;
              background-color: #0C2846;
            }
          }
          .terms-policy {
            position: fixed;
            padding: 0;
            margin: 0;
            border-radius: 10px;
            width: 90%;
            max-width: 576px;
            height: auto;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .modal-content {
              border-radius: 10px;
              box-shadow: none;
              border: none;
            }
            .modal-body {
              padding: 0 !important;
            }
            &__title {
              color: #0C2846 !important;
              padding: 16px 24px;
              border-bottom: 1px solid #e3ecf5;
              font-weight: bold !important;
            }
            &__text {
              color: #0C2846 !important;
              margin-bottom: 8px !important;
            }
            &__content {
              padding: 24px;
              border-bottom: 1px solid #e3ecf5;
            }
            &__link {
              color: #00C2C9 !important;
              &:hover {
                text-decoration: underline;
              }
            }
            &__checkbox-container {
              padding-top: 8px;
            }
            &__checkbox {
              padding-top: 8px;
              margin: 0 !important;
              .new-checkbox-indicator {
                margin: 0 8px;
              }
              &:hover {
                background-color: #F6F7FA;
                border-radius: 4px;
              }
              .new-checkbox-indicator,
              svg {
                width: 24px !important;
                height: 24px !important;
              }
            }
            &__btn-group {
              padding: 16px 24px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              column-gap: 8px;
              button {
                margin: 0;
                height: 40px;
                padding: 12px 24px;
                font-weight: bold;
                font-size: 12px;
                display: flex;
                align-items: center;
              }
              .button-default {
                border: none;
                &:hover {
                  background-color: #7ADEE3;
                }
                &:active {
                  background-color: #0090a3;
                }
              }
            }
            @media screen and (min-width: 768px) {
              &__text {
                font-size: 16px !important;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

CompleteSignUpNotice.propTypes = {
  currentUser: PropTypes.object,
}

export { CompleteSignUpNotice }
export default branch({
  currentUser: ['serverProps', 'currentUser'],
  agreedToCampusTerms: ['serverProps', 'currentUser', 'agreed_to_campus_terms'],
  agreedToCampusPolicy: ['serverProps', 'currentUser', 'agreed_to_campus_policy'],
}, CompleteSignUpNotice)
